import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';
import { useMobile, useIsPWA } from '../../../../contexts/PWAContext';

interface QRScannerProps {
  show?: boolean;
  error?: string;
}
export function QRScanner(props: QRScannerProps) {
  const { show, error } = props;
  const isMobile = useMobile();
  const isPWA = useIsPWA();
  const isNativeMobile = isMobile && !isPWA;

  return show ? (
    error ? (
      <Typography
        sx={{
          color: alpha('#e74c3c', 1),
          backgroundColor: alpha('#ffffff', 1),
        }}
        variant={'caption'}
      >
        {error}
      </Typography>
    ) : (
      <Box
        id="qr-scanner-anchor"
        sx={
          isNativeMobile
            ? {
                position: 'relative',
                display: 'inline-flex',
                width: '200px',
                height: '200px',
                borderRadius: '4px',
                border: '1px solid grey',
              }
            : {
                position: 'relative',
                display: 'inline-flex',
                width: '100%',
              }
        }
      ></Box>
    )
  ) : (
    <div></div>
  );
}
